// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a {text-decoration: none; color:black}
a:visited {color: black;text-decoration: none;}
a:hover {color: gray;text-decoration: none;}


.footerDiv {
  background-color: tomato;
  display: flex;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/components/footer.css"],"names":[],"mappings":"AAAA,GAAG,qBAAqB,EAAE,WAAW;AACrC,WAAW,YAAY,CAAC,qBAAqB,CAAC;AAC9C,SAAS,WAAW,CAAC,qBAAqB,CAAC;;;AAG3C;EACE,wBAAwB;EACxB,aAAa;EACb,uBAAuB;AACzB","sourcesContent":["a {text-decoration: none; color:black}\na:visited {color: black;text-decoration: none;}\na:hover {color: gray;text-decoration: none;}\n\n\n.footerDiv {\n  background-color: tomato;\n  display: flex;\n  justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
